import angular from "angular";
import core from "../../core/core.module";
import mobiusError from '../mobius-error';
import mobiusNotification from '../mobius-notification';

angular
    .module('mobiusControl.errorNotifications', [core, mobiusError, mobiusNotification])
    .component('errorNotifications', {
        controller: ['notifier', 'MobiusError', 'MobiusNotification', controller],
        template: require('./error-notifications.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, MobiusError, MobiusNotification) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.mobiusError = $ctrl.resolve.mobiusError;
        $ctrl.form = {
            errorType: $ctrl.mobiusError.type,
            errorCode: $ctrl.mobiusError.code,
            errorMessage: $ctrl.mobiusError.message,
            requestSlug: $ctrl.mobiusError.request_slug,
            emails: null
        };
    };

    $ctrl.update = function (notification) {
        MobiusNotification
            .update(notification.id, {
                errorType: notification.error_type,
                errorCode: notification.error_code,
                errorMessage: notification.error_message,
                requestSlug: notification.request_slug,
                emails: notification.emails,
            })
            .then(
                function () {
                    notifier.successNotify('Данные успешно обновились');
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            )
    };

    $ctrl.add = function () {
        MobiusNotification
            .store($ctrl.form)
            .then(
                function (response) {
                    $ctrl.mobiusError.notifications.push({
                        id: response.data.id,
                        error_type: $ctrl.form.errorType,
                        error_code: $ctrl.form.errorCode,
                        error_message: $ctrl.form.errorMessage,
                        request_slug: $ctrl.form.requestSlug,
                        emails: $ctrl.form.emails
                    });
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.destroy = function (notification, ind) {
        if (!confirm('Вы действительно хотите удалить уведомление?')) {
            return;
        }
        MobiusNotification.destroy(notification.id).then(
            function () {
                notifier.successNotify('Обработчик успешно удален');
                $ctrl.mobiusError.notifications.splice(ind, 1);
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        )
    };
}

export default 'mobiusControl.errorNotifications';



// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/error-notifications/error-notifications.js